import MarketingSection from './marketingSection'

export default MarketingSection
